<div class="pm-form-field-radio-tile-container" #container>
  <div
    class="pm-form-field-radio-tile-option mb-3"
    *ngFor="let option of formField.options"
    (click)="onTileClick(option.value)"
    (keyup.enter)="onTileClick(option.value)"
    role="presentation"
  >
    <div class="pm-form-field-radio-button-container">
      <p-radioButton
        [name]="formField.name"
        [value]="option.value"
        [inputId]="option.value"
        [formControl]="ctrl"
        styleClass="pm-form-field-radio-button"
        class="pm-form-field-radio-tile-radio-button"
      />
    </div>
    <div class="pm-form-field-radio-tile-image-container" *ngIf="option?.imgSrc">
      <img [src]="option?.imgSrc" [alt]="option.label" />
    </div>
    <div class="pm-form-field-radio-tile-option-content p-2-5">
      <div class="pm-form-field-radio-tile-label p4">
        {{ option.label }}
      </div>
      <div class="pm-form-field-radio-tile-description p5 pt-1" *ngIf="option.description">
        {{ option.description }}
      </div>
    </div>
  </div>
</div>
